import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//                     Отправить запрос на удаление комментария
//------------------------------------------------------------------------------
export const deleteComment = async ({ commentId }) => {
  try{
    const url = `${backendUrl}/api/comments/delete/${ commentId }/`;
    const options = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    };
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при удалении комментария: HTTP error! Status: ${ response.status }`);
    }
    return response;
  } catch(error){
    console.error('Программная ошибка удаления комментария:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx